import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Plus, Pencil, Trash2 } from "lucide-react";

const EMPTY = { name: "", code: "", description: "", discount_type: "percent", discount_value: 10, applies_to: "all", min_order: 0, active: true, image: "" };

export default function AdminPromotions() {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);
  const load = () => api.get("/promotions?active_only=false").then(({data}) => setItems(data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const save = async () => {
    try {
      if (editing.id) await api.put(`/promotions/${editing.id}`, editing);
      else await api.post("/promotions", editing);
      toast.success("Saved"); setEditing(null); load();
    } catch (e) { toast.error("Save failed"); }
  };
  const del = async (id) => { if (!confirm("Delete?")) return; await api.delete(`/promotions/${id}`); load(); };
  return (
    <div data-testid="admin-promos">
      <div className="flex justify-between mb-5"><h1 className="font-heading text-3xl text-[#FAF9F6]">Promotions</h1>
      <button onClick={() => setEditing({...EMPTY})} className="btn-chow"><Plus className="w-4 h-4 inline"/> New</button></div>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map(p => (
          <div key={p.id} className="admin-card p-5">
            <div className="flex justify-between mb-1">
              <span className={`badge-${p.active ? 'fresh' : 'royal'}`}>{p.active ? "ACTIVE" : "OFF"}</span>
              <div className="flex gap-2">
                <button onClick={() => setEditing(p)} className="text-[#D4AF37]"><Pencil className="w-4 h-4"/></button>
                <button onClick={() => del(p.id)} className="text-[#E8A87C]"><Trash2 className="w-4 h-4"/></button>
              </div>
            </div>
            <h3 className="font-heading text-xl text-[#D4AF37]">{p.name}</h3>
            <p className="text-xs text-[#FAF9F6]/60 my-2">{p.description}</p>
            <div className="font-mono text-[#D4AF37] font-bold">{p.code}</div>
            <div className="text-xs text-[#FAF9F6]/50">{p.discount_type === "percent" ? `${p.discount_value}% off` : `$${p.discount_value} off`} · {p.applies_to}</div>
          </div>
        ))}
      </div>
      {editing && (
        <div className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center p-4">
          <div className="admin-card p-6 w-full max-w-md">
            <h3 className="font-heading text-2xl text-[#D4AF37] mb-3">{editing.id ? "Edit" : "New"} promo</h3>
            <div className="space-y-2 text-sm">
              <input value={editing.name} onChange={(e) => setEditing({...editing, name: e.target.value})} placeholder="Name" className="w-full bg-[#0B0E14] border border-[#D4AF37]/30 px-3 py-2 rounded text-[#FAF9F6]"/>
              <input value={editing.code} onChange={(e) => setEditing({...editing, code: e.target.value.toUpperCase()})} placeholder="CODE" className="w-full bg-[#0B0E14] border border-[#D4AF37]/30 px-3 py-2 rounded text-[#FAF9F6] font-mono"/>
              <textarea rows={2} value={editing.description} onChange={(e) => setEditing({...editing, description: e.target.value})} placeholder="Description" className="w-full bg-[#0B0E14] border border-[#D4AF37]/30 px-3 py-2 rounded text-[#FAF9F6]"/>
              <div className="grid grid-cols-2 gap-2">
                <select value={editing.discount_type} onChange={(e) => setEditing({...editing, discount_type: e.target.value})} className="bg-[#0B0E14] border border-[#D4AF37]/30 px-3 py-2 rounded text-[#FAF9F6]">
                  <option value="percent">% off</option><option value="fixed">$ off</option><option value="free_delivery">Free delivery</option>
                </select>
                <input type="number" step="0.01" value={editing.discount_value} onChange={(e) => setEditing({...editing, discount_value: parseFloat(e.target.value)})} className="bg-[#0B0E14] border border-[#D4AF37]/30 px-3 py-2 rounded text-[#FAF9F6]"/>
              </div>
              <select value={editing.applies_to} onChange={(e) => setEditing({...editing, applies_to: e.target.value})} className="w-full bg-[#0B0E14] border border-[#D4AF37]/30 px-3 py-2 rounded text-[#FAF9F6]">
                {["all","restaurant","grocery","catering","lechon"].map(x => <option key={x}>{x}</option>)}
              </select>
              <label className="flex gap-2 text-xs text-[#FAF9F6]"><input type="checkbox" checked={editing.active} onChange={(e) => setEditing({...editing, active: e.target.checked})}/> Active</label>
            </div>
            <div className="flex gap-2 mt-4">
              <button onClick={save} className="btn-chow flex-1">Save</button>
              <button onClick={() => setEditing(null)} className="btn-chow-outline flex-1">Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
